import { render, staticRenderFns } from "./EthereumIcon.vue?vue&type=template&id=f0aefbac&"
import script from "./EthereumIcon.vue?vue&type=script&lang=ts&"
export * from "./EthereumIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports